//Change this value to OSUWMC if login to OSUWMC AD, to OSU if login to OSU, AZURE if login to Azure
//AZURE is not working yet
export const loginAgency = process.env.REACT_APP_LOGIN_AGENCY;

export const EmptyAppContext = {
    username: "",
    employeeId: "",
    fullName: "",
    roles: [],
    accessToken: "",
    sbToken: "",
    accessTokenExpiresUTC: "",
    isAuthenticated: false,
    authenticateAgency: loginAgency,
    updateContext: () => { },
    setApiMessage: () => { }
};


//Check user roles from context
export const isUserAuthenticated = (context) => {
    return (context && context.isAuthenticated);
}

//Check user roles from context
export const isUserInRoles = (roles, context) => {

    if (context && context.isAuthenticated && context.roles) {
        let targetRoles = roles.split(',');
        let inRole = context.roles.some((r) => targetRoles.indexOf(r) >= 0);
        return inRole;
    }

    return false;
}

//Get user Name
export const getUserName = (context) => {
    return context.username;
}